import api from "PFCore/api/api";
import { Collection } from "PFTypes";
import { Feature } from "PFTypes/features";

export const fetchFeatures = (
  accountId: number,
  page: number,
  perPage: number
): Promise<Collection<Feature[]>> =>
  api({
    url: "features",
    method: "get",
    params: {
      accountId,
      page,
      perPage
    }
  });

export const toggleFeature = (feature: Feature, accountId: number): Promise<Feature> =>
  api({
    url: `features/${feature.id}`,
    method: "put",
    params: {
      account_id: accountId
    },
    data: {
      active: !feature.active
    }
  });
